import { toast } from "react-toastify";
import { API_LIMIT, MAX_LIMIT, START_PAGE } from "../../utils/Constant";
import { getAllTemplatesData, getCategoryData } from "./PersonalizationAction";
import { postLoginInstance } from "../../utils";
import { getAllContentTemplates } from "../MasterCategory/MasterCategoryAction";
import { filterVerifiedItems } from "../../utils/ReusableFunctions";

export const getAllTemplatesApi = (ctx = null) => {
  return function (dispatch, getState) {
    ctx?.setState?.({ isLoading: true })
    const params = new URLSearchParams(ctx?.props?.location?.search);
    const searchValue = params.get("search") || "";
    const verifyUrl = params.get("isVerified") ? `isVerified=${params.get("isVerified")}` : "";
    const pageSize = parseInt(params.get("pageSize"), 10) || API_LIMIT;
    const pageNumber = parseInt(params.get("page"), 10) || START_PAGE;

    return postLoginInstance.get(`personalization/template?${verifyUrl ? verifyUrl + '&' : ''}pageSize=${pageSize || API_LIMIT}&pageNumber=${pageNumber || START_PAGE}${searchValue && `&searchValue=${searchValue}`}`)
      .then((res) => {


        dispatch(getAllTemplatesData(res.data.data, pageNumber || START_PAGE));

      })
      .catch((error) => {
        toast.error(error?.response?.data?.message || "Something went wrong")
      }).finally(() => {
        ctx?.setState?.({ isLoading: false })
      })
  }

};

export const getAllCustomTemplatesApi = (ctx = null) => {
  ctx?.setState?.({ isLoading: true })
  return function (dispatch, getState) {
    const params = new URLSearchParams(window.location.search);
    const searchValue = params.get('search') || '';
    const size = params.get("pageSize") || "";
    const verifyUrl = params.get("isVerified") ? `isVerified=${params.get("isVerified")}` : "";
    return postLoginInstance.get(`personalizationCustomTemplate?${verifyUrl ? verifyUrl + '&' : ''}pageSize=${size || API_LIMIT}&pageNumber=${ctx?.state.currentPage || START_PAGE}${searchValue ? `&searchValue=${searchValue}` : ""}`)
      .then((res) => {


        dispatch(getAllContentTemplates(res.data.data, ctx?.state.currentPage || START_PAGE));

      })
      .catch((error) => {
        toast.error(error?.response?.data?.message || "Something went wrong")
      }).finally(() => {
        ctx?.setState?.({ isLoading: false })
      })
  }

};


export const getDetailsTemplateApi = (path, ctx) => {
  console.log(ctx, "subdomain")
  return postLoginInstance.get(`${path}/${ctx.props?.location?.state?.id || ctx.props.match?.params.id}`)
    .then((res) => {
      const d = res.data.data
      const processedVariations = d.personalizationTemplateVariations?.map(module => {
        const processedVariations = {
          languageUuid: module?.language?.uuid,
          personalizationTemplateVariationImages:
            module?.personalizationTemplateVariationImages

        };
        return processedVariations;
      });
      return ctx.setState({
        editData: d, templateUuid: d?.uuid || "", templateName: d?.templateName || "", variations: processedVariations, categoryUuid: d?.personalizationCategory?.uuid, uploadImage: d?.thumbnailImage, isPremium: d?.isPremium ? 'true' : 'false',
      });
    })
    .catch((err) => {
      console.log('Eroorr', err)
      toast.error(err?.response?.data?.message || 'Something went wrong.');
    })
};

export const getTemplateDetailsApi = (path, ctx) => {

  return postLoginInstance.get(`${path}/${ctx.props?.location?.state?.id || ctx.props.match?.params.id}`)
    .then((res) => {
      return ctx.setState({ data: res?.data?.data });

    })
    .catch((err) => {
      console.log('Eroorr', err)
      toast.error(err?.response?.data?.message || 'Something went wrong.');
    })
};
export const getPersonalizationCategoryApi = (ctx = null, onHide = null) => {
  ctx?.setState?.({ isLoading: true })
  return function (dispatch, getState) {
    const params = new URLSearchParams(ctx?.props?.location?.search);
    const searchValue = params.get("search") || "";
    const verifyUrl = params.get("isVerified") ? `isVerified=${params.get("isVerified")}` : "";
    let pageSize = parseInt(params.get("pageSize"), 10) || API_LIMIT;
    if (ctx?.state.isAddContent) {
      pageSize = MAX_LIMIT;
    }
    const pageNumber = parseInt(params.get("page"), 10) || START_PAGE;
    return postLoginInstance
      .get(
        `personalization/category?${verifyUrl ? verifyUrl + '&' : ''}pageSize=${pageSize || MAX_LIMIT}&pageNumber=${pageNumber || START_PAGE
        }${searchValue && `&searchValue=${searchValue}`}`
      )
      .then((res) => {
        if (ctx?.state.isAddContent) {
          const option = filterVerifiedItems(res.data.data.list).map((item) => ({
            label: item.categoryName,
            value: item.uuid
          }));
          ctx.setState({
            categoryOptions: option
          })
        } else {
          dispatch(
            getCategoryData(res.data.data, ctx?.state.currentPage || START_PAGE)
          );
        }
        if (!ctx) {
          onHide();
        }
      }).catch((error) => {
        toast.error(error?.response?.data?.message || 'Something went wrong.');
      }).finally(() => {
        ctx?.setState?.({ isLoading: false })
      })
  };
};


export const addPersonalizationCategoryApi = (data, ctx, onHide, ctx2) => {
  return postLoginInstance.post("personalization/category", data).then((res) => {
    ctx.props.getPersonalizationCategoryApi(null, onHide);
    toast.success("Added Successfully.")
    ctx2?.setState({ resLoading: false })
  }).catch((error) => {
    ctx2?.setState({ resLoading: false })
    toast.error(error?.response?.data?.message || 'Something went wrong.');
  })
};
export const deletePersonalizationCategoryApi = (id, ctx, onHide) => {
  return postLoginInstance.delete(`personalization/category/${id}`).then((res) => {
    ctx.props.getPersonalizationCategoryApi(null, onHide);
    toast.success("Successfully Deleted.")
  }).catch((error) => {
    toast.error(error?.response?.data?.message || 'Something went wrong.');
  })
};
export const updatePersonalizationCategoryApi = (data, ctx, onHide, id) => {
  return postLoginInstance.put(`personalization/category/${id}`, data).then((res) => {
    ctx.props.getPersonalizationCategoryApi(null, onHide);
    toast.success("Successfully Updated.")
  }).catch((error) => {
    toast.error(error?.response?.data?.message || 'Something went wrong.');
  })
};